module.exports = __webpack_public_path__ + "static/img/banner-id.32c36e1e.png";